

















































































































import {
  defineComponent,
  ref,
  reactive,
  computed,
  PropType,
} from '@vue/composition-api';
import Store from '@/store';
import {
  ITemplateSectionField, ISelectFieldOption, VForm, ITableFieldColumns,
} from '@/types';
import InnerConfigTableComponent from './InnerConfigTableComponent.vue';

export default defineComponent({
  components: {
    InnerConfigTableComponent,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    field: {
      type: Object as PropType<ITemplateSectionField>,
      default: () => {},
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    isPublished: {
      type: Boolean,
      required: true,
    },
    subsectionIndex: {
      type: Number,
      required: false,
    },
  },

  setup(props) {
    const form = ref(null as unknown as VForm);

    const dialog = ref(false);

    const sectionFieldName = props.sectionName;

    // TODO remove ID key when updating validation
    const fieldData = reactive({
      fieldId: '',
      id: 0,
      inboundMapping: '',
      outboundMapping: '',
      name: '',
      value: '',
      required: false,
      type: '',
      readonly: false,
      structure: [] as ITableFieldColumns[],
    }) as ITemplateSectionField;

    const tableHeaders = [
      { text: 'Column Name', value: 'text', width: '80%' },
      {
        text: '', value: 'actions', sortable: false, align: 'right',
      },
    ];

    /**
     * Method triggered when user opens dialog
     * searches field data based off index position
     * returns field data stored and assigns it to main field data obj
     */
    const getFieldData = () => {
      const fieldSavedData = Store.getters['templateCustomisation/getSectionFieldData']({
        sectionName: sectionFieldName,
        subsectionIndex: props.subsectionIndex,
        fieldIndex: props.index,
      }) as ITemplateSectionField;

      Object.keys(fieldSavedData).forEach((key) => {
        fieldData[key] = fieldSavedData[key];
      });
    };

    /**
     * Disables saving if no options entered
     */
    const optionsSelected = computed(
      () => fieldData.structure && fieldData.structure.length,
    );

    /**
     * Closes dialog box
     */
    const closeDialog = () => {
      getFieldData();
      dialog.value = false;
    };

    // Validation for Length of Label
    const rules = {
      lengthRule: (v: string) => (v && v.length <= 100) || 'Label must be less than 100 characters',
    };

    /**
     * Returns title card text depending on published status
     */
    const getCardTitleText = computed(() => {
      let title = `Configure '${fieldData.name}' ${props.field ? props.field.type : ''} Component`;
      if (props.isPublished) title = title.replace('Configure', 'View');
      return title;
    });

    /**
     * Return cancel button text depending on published status
     */
    const getCloseBtnText = computed(() => (props.isPublished ? 'Close' : 'Cancel'));

    /**
     * Saves new/edited select option values from Select Data Table
     */
    const saveNewOptionValues = (updatedOptions: ISelectFieldOption[]) => {
      if (fieldData) fieldData.structure = updatedOptions;
    };

    /**
     * Save updated data into vuex
     */
    const saveValues = () => {
      // Dont allow user to confirm if form validation fails
      if (!form.value.validate()) return;

      const fieldDetails = {
        sectionName: sectionFieldName,
        subsectionIndex: props.subsectionIndex,
        index: props.index,
        fieldData,
      };
      Store.dispatch(
        'templateCustomisation/updateIndividualField',
        fieldDetails,
      );
      dialog.value = false;
    };

    return {
      form,
      rules,
      dialog,
      closeDialog,
      fieldData,
      tableHeaders,
      saveValues,
      getFieldData,
      sectionFieldName,
      saveNewOptionValues,
      getCardTitleText,
      getCloseBtnText,
      optionsSelected,
    };
  },
});
